<template>
    <form action="/explosive-hazards/all-hazards" class="form form-search d-flex flex-col justify-content-center">
        <div class="field position-relative w-100">
            <div class="control">
                <input class="input w-100 border-radius" name="query" type="text" :value="query" placeholder="E.g. Type 58 Landmine"/>
            </div>
            <div class="control">
                <button class="btn btn-search"></button>
            </div>
        </div>
        <div class="text-sm mx-auto mt-3 px-3 text-center">
            You may also search by <div class="block sm:hidden"></div><a class="text-[#E57722] underline font-medium" href="/explosive-hazards/incidents">Incidents</a> or <a class="text-[#E57722] underline font-medium" href="/explosive-hazards/terrorist-groups">Terrorist Groups</a>
        </div>


    </form>
</template>

<script>
    export default {
        name: "CatUxoSearch",
        props: {
          query: {
              type: String,
              required: false,
              default: ''
          }
        },
        mounted() {
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/SearchBox.vue